let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aLcFc")).then(() => parcelRequire('79afE'));